import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';


const CommentModalComp = (props) => {

    const [comment, setComment] = useState(props.comment ? props.comment : '---')

    useEffect(() => {
        if (props.comment && props.comment != '') {
            setComment(props.comment)
        }
        else {
            setComment('---')
        }
    }, [])

    return (

        <Modal
            size='m'
            show={props.show}
            onHide={props.handleClose}
            backdrop="static"
            centered
            keyboard={false}
        >
            <Modal.Header style={{ backgroundColor: 'rgb(0, 42, 74)' }}>
                <Modal.Title style={{ fontFamily: 'Roboto', color: 'white' }}>
                    {props.title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row col-12 col-sm-12 col-md-12 col-lg-12">
                    <label style={{ fontSize: 16, marginRight: 12 }}>  {'Comment :'} {comment}</label>
                </div>
            </Modal.Body>


            <Modal.Footer>
                <div className="row col-12 col-sm-12 col-md-12 col-lg-12" style={{ display: 'flex', justifyContent: 'space-between' }}>

                    <button
                        style={{ backgroundColor: '#002a4a', height: '80%', color: 'white', width: '100%', borderRadius: 8, borderWidth: 1 }}
                        onClick={() => {
                            props.show(false)
                        }} className='btn btn-primary' variant="primary">
                        {'OK'}
                    </button>
                </div>
            </Modal.Footer>

        </Modal >
    );
}
export default CommentModalComp;